// extracted by mini-css-extract-plugin
export var animationContainer = "_m8-0";
export var footer = "_m8-1";
export var gray = "_m8-2";
export var lineItem = "_m8-3";
export var lineItemImage = "_m8-4";
export var lineItemInfo = "_m8-5";
export var lineItemText = "_m8-6";
export var lineItems = "_m8-7";
export var modalContent = "_m8-8";
export var options = "_m8-9";
export var orderName = "_m8-a";
export var refundAmount = "_m8-b";